import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AclToolsService } from 'src/app/acl/tools/acl-tools.service';
import { AclResource } from 'src/app/acl/tools/decorators/acl-resource';
import { OrganizationRoleMap } from 'src/app/organization/shared/organization.types';
import { AclBusinessRoleType } from 'src/app/shared/types/acl.types';

/**
 * @todo: Clean up these resources
 * @todo: We should have global resource which defines if we can show oragnizations
 */
export const ACL_RESOURCES = {
  MANAGE_USERS: 'organizationAccountManagement',
  GET_ORGANIZATION: 'getOrganization',
};

@Injectable({
  providedIn: 'root'
})
export class OrganizationAclService {
  @AclResource(ACL_RESOURCES.GET_ORGANIZATION)
  public readonly canGetOrganization$: Observable<boolean>;

  public readonly aclTools: AclToolsService;

  constructor() {
    this.aclTools = inject(AclToolsService);
  }

  public get rolePerOrg(): OrganizationRoleMap | undefined {
    return this.aclTools.aclService.aclSnapshot
      ?.groupAuthDto
      .filter(group => group.roleType === AclBusinessRoleType.ORGANIZATION)
      .flatMap(group => group.items)
      .reduce((acc, item) => ({ ...acc, [item.id]: item.businessRoles[0] }), {});
  }

  public canManageOrganization(organizationsId: string): Observable<boolean> {
    return this.aclTools.aclService.aclMapByOrg$
      .pipe(map(() => this.aclTools.isAllowedForOrganizationsInstant([ACL_RESOURCES.MANAGE_USERS], organizationsId)));
  }
}
